import { Link } from "react-router-dom";
import { Linkedin, Mail } from "lucide-react";
import ttmLogoLight from "@/assets/ttm-logo-light.png";

export const Footer = () => {
  return (
    <footer data-testid="main-footer" className="bg-ink text-ivory">
      <div className="container-px py-20 grid gap-12 md:grid-cols-12">
        <div className="md:col-span-5">
          <img src={ttmLogoLight} alt="Tough Trust Method" className="h-11 w-auto" />
          <p className="text-ivory/80 mt-6 max-w-sm font-light leading-relaxed">
            A Board-level commitment that combines high trust with rigorous, transparent processes –
            so the fraudster and the disruptive maverick never get to define your organisation's
            culture.
          </p>
        </div>

        <div className="md:col-span-3">
          <p className="overline !text-ivory/80">Explore</p>
          <ul className="mt-5 space-y-3 text-ivory/80">
            <li><Link to="/method" className="hover:text-gold transition-colors" data-testid="footer-link-method">The Method</Link></li>
            <li><Link to="/on-leadership" className="hover:text-gold transition-colors" data-testid="footer-link-onleadership">On Tough Trust</Link></li>
            <li><Link to="/coaching-pairs" className="hover:text-gold transition-colors" data-testid="footer-link-pairs">Coaching Pairs</Link></li>
            <li><Link to="/about" className="hover:text-gold transition-colors" data-testid="footer-link-about">About Pete</Link></li>
          </ul>
        </div>

        <div className="md:col-span-4">
          <p className="overline !text-ivory/80">Get in touch directly</p>
          <a
            href="mailto:pete@peteashbycoaching.com"
            data-testid="footer-email-link"
            className="inline-flex items-center gap-2 mt-5 text-lg text-ivory hover:text-gold transition-colors"
          >
            <Mail size={18} /> pete@peteashbycoaching.com
          </a>
          <div className="flex items-center gap-4 mt-6">
            <a
              href="https://www.linkedin.com/in/pashby/"
              target="_blank"
              rel="me noopener"
              data-testid="footer-linkedin"
              className="w-11 h-11 grid place-items-center border border-ivory/20 hover:border-gold hover:text-gold transition-colors"
              aria-label="Pete Ashby on LinkedIn"
            >
              <Linkedin size={18} />
            </a>
          </div>
        </div>
      </div>

      <div className="border-t border-ivory/10">
        <div className="container-px py-6 flex flex-col sm:flex-row items-center justify-between gap-3 text-ivory/80 text-sm">
          <p>© {new Date().getFullYear()} Pete Ashby · The Tough Trust Method. All rights reserved.</p>
          <p className="font-light">Website designed by Evie Ashby · Ashby London Ltd.</p>
        </div>
      </div>
    </footer>
  );
};
